import { render, staticRenderFns } from "./bumdesRepport.vue?vue&type=template&id=0fb59774&"
import script from "./bumdesRepport.vue?vue&type=script&lang=js&"
export * from "./bumdesRepport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports